import { axios, Response } from '../index'
import { AccessProfile } from './get-clinic-operators'

export interface OperationalInfo {
  id: string
  login: string
  firstName: string
  lastName: string
  cpfOrPassport: string
  email: string
  avatarUrl: string
  accessProfiles: AccessProfile[]
}

export default async function getOperationalById(
  operationalId: string
): Response<OperationalInfo> {
  return await axios.get(`/v1/operators/${operationalId}`)
}
